// assets
import { CalendarOutlined, ShopOutlined, ShoppingOutlined, BarChartOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
  CalendarOutlined,
  ShopOutlined,
  ShoppingOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

const pages = {
  id: 'admin-pages',
  title: '',
  type: 'group',
  children: [
    {
      id: 'event',
      title: 'Event',
      type: 'item',
      url: '/event',
      icon: icons.CalendarOutlined,
      breadcrumbs: true
      // target: true
    },
    // {
    //   id: 'po',
    //   title: 'PO',
    //   type: 'item',
    //   url: '/po',
    //   icon: icons.ShopOutlined,
    //   breadcrumbs: true
    //   // target: true
    // },
    // {
    //   id: 'jastip',
    //   title: 'Jastip',
    //   type: 'item',
    //   url: '/jastip',
    //   icon: icons.ShoppingOutlined,
    //   breadcrumbs: true
    //   // target: true
    // }
  ]
};

if (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) {
  // pages.children.unshift({
  //   id: 'places',
  //   title: 'Places',
  //   type: 'item',
  //   url: '/places',
  //   icon: icons.HomeOutlined,
  //   breadcrumbs: true
  //   // target: true
  // })
  // pages.children.push({
  //   id: 'report',
  //   title: 'Reports',
  //   type: 'item',
  //   url: '/report',
  //   icon: icons.BarChartOutlined,
  //   breadcrumbs: true
  //   // target: true
  // })
}

export default pages;
